import type { CaravanMissingInformationDTO } from 'gw-edge-client/dist/types/dto/pc/top/edge/capabilities/onlinesales/dto/missingInformation/';
import { TextField, GridItem } from '@flos/react-ui';
import { useRecoilState } from 'recoil';
import { missingInformationAtom } from '../../../recoil/atoms/missingInformationAtom';
import { useHippoText } from '../../../hooks/useHippoText';
import type { CaravanDTO } from 'gw-edge-client/dist/types/dto/pc/top/edge/capabilities/onlinesales/dto/uvp';

const CaravanMissingInformationForm = ({
    caravanMissingDTO,
    currentCoverable
}: {
    caravanMissingDTO: CaravanMissingInformationDTO;
    currentCoverable: CaravanDTO;
}): React.JSX.Element => {
    const getHippoText = useHippoText();
    const [missingInformation, setMissingInformation] = useRecoilState(missingInformationAtom);
    const { fixedId, vin } = caravanMissingDTO;

    const updateMissingInformationProperty = (fixedId: string, updateValue: object): void => {
        const updateCaravan = missingInformation.caravan?.map((item) => {
            if (item.fixedId !== fixedId) return item;
            return {
                ...item,
                ...updateValue
            };
        });
        setMissingInformation((previousState) => {
            return {
                ...previousState,
                caravan: updateCaravan
            };
        });
    };

    return (
        <>
            <GridItem span={12}>
                <h6>{currentCoverable.flavourName}</h6>
            </GridItem>
            <GridItem span={12}>
                <h6>{getHippoText('DSS-CHECKOUT-ADDITIONAL-INFORMATION-CARAVAN-VIN-HEADER')}</h6>
            </GridItem>
            <GridItem span={6}>
                <TextField
                    maxLength={255}
                    pattern="[a-zA-Z0-9]+"
                    label={getHippoText('DSS-CHECKOUT-ADDITIONAL-INFORMATION-CARAVAN-VIN-FIELD')}
                    value={vin ?? ''}
                    onChange={(data) => {
                        updateMissingInformationProperty(fixedId ?? '', {
                            vin: data.target.value
                        });
                    }}
                    showLength={false}
                />
            </GridItem>
        </>
    );
};
export default CaravanMissingInformationForm;
